import * as next from '../../../types/next'
import { CONTROL_NAME } from '../../../utils'
import type { UpBlockHandler } from '../types'

import { upCommonSettings } from './common'

export const up: UpBlockHandler<next.SignatureBlock> = (uischema) => {
  if (uischema.type !== CONTROL_NAME.DIGITAL_SIGNATURE_CONTROL) {
    throw new Error('Expected a valid Digital Signature control')
  }

  return {
    type: next.BLOCK_TYPE.SIGNATURE,
    settings: upCommonSettings(uischema),
    references: {}
  }
}
